module.exports = __webpack_public_path__ + "img/var_03_circle2.b786f40e.svg";